import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const included = [['120 Complete Ready-to-Teach Dance Fitness Classes', 'Fully structured from warm-up to cool-down — open and teach'], ['120 Professional Choreography Systems', 'Ready-to-follow movement combinations for every single class'], ['Complete Cueing & Coaching System', 'Improve communication, class flow, motivation and engagement'], ['Class Planning Frameworks', 'Organize an entire year of classes in minutes instead of hours'], ['Progressive Difficulty Systems', 'Designed for beginners, intermediate, mixed-level and advanced groups'], ['Music & Playlist Organization Guides', 'Create more dynamic, energetic classes with the right soundtrack'], ['Warm-Up, Mobility & Cool-Down Libraries', 'Ready to combine with any class — no extra planning needed'], ['Movement Combination Libraries', 'Create unlimited choreography variations from a single resource'], ['Class Structure Templates', 'Ready formats for 30, 45 and 60-minute sessions'], ['Instructor Cue Sheets', 'Motivational coaching phrases and professional teaching cues'], ['Participant Progress & Attendance Trackers', 'Stay organized and track your students with zero effort'], ['Class Preparation Checklists', 'Every session fully planned before you walk into the studio'], ['Printable Instructor Resources', 'Ready to use immediately — no extra setup required']];
export function ClassLibrary() {
  return <section className="bg-charcoal px-4 py-20 sm:py-24" data-id="element-39">
      <div className="mx-auto max-w-6xl" data-id="element-40">
        <header className="mx-auto mb-14 max-w-3xl text-center" data-id="element-41">
          <h2 className="font-display text-3xl font-bold text-white sm:text-5xl" data-id="element-42">
            120 Complete Ready-to-Teach Dance Fitness Classes
          </h2>
          <p className="mt-3 text-base text-gold-light" data-id="element-43">
            Fully Structured from Warm-Up to Cool-Down · 52+ Weeks of Fresh
            Content · Nothing to Build From Scratch
          </p>
        </header>

        <motion.article initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-3xl border border-gold/30 bg-charcoal-card p-6 sm:p-9" data-id="element-44">
          <p className="text-xs font-bold uppercase tracking-[.18em] text-gold-light" data-id="element-45">
            The complete core system
          </p>
          <h3 className="mt-3 font-display text-3xl font-bold text-white" data-id="element-46">
            Dance Fitness Instructor Pro — Everything Inside
          </h3>

          <div className="mt-6 grid gap-6 border-y border-charcoal-line py-6 md:grid-cols-2" data-id="element-47">
            <div data-id="element-48">
              <h4 className="font-semibold text-white" data-id="element-49">
                What does it solve in your teaching?
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400" data-id="element-50">
                Teaching dance fitness week after week is rewarding — and
                demanding. The energy, variety, choreography, student
                motivation, and class structure all have to come together every
                session.
              </p>
            </div>
            <p className="text-sm leading-relaxed text-zinc-300" data-id="element-51">
              This system gives you everything you need to walk into every class
              with structure, flow, energy, and confidence — without improvising
              a single moment or spending hours planning the night before.
            </p>
          </div>

          <div className="mt-8 overflow-hidden rounded-2xl border border-charcoal-line" data-id="element-52">
            <div className="grid grid-cols-1 border-b border-charcoal-line bg-gold/10 text-xs font-bold uppercase tracking-wider text-gold-light sm:grid-cols-2" data-id="element-53">
              <p className="p-4" data-id="element-54">What's Included</p>
              <p className="border-t border-charcoal-line p-4 sm:border-l sm:border-t-0" data-id="element-55">
                What It Does For You
              </p>
            </div>
            {included.map(([title, description]) => <div key={title} className="grid grid-cols-1 border-b border-charcoal-line last:border-0 sm:grid-cols-2" data-id="element-56">
                <p className="flex gap-2 p-4 text-sm font-medium text-white" data-id="element-57">
                  <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-gold-light" data-id="element-58" />
                  {title}
                </p>
                <p className="border-t border-charcoal-line p-4 text-sm text-zinc-400 sm:border-l sm:border-t-0" data-id="element-59">
                  {description}
                </p>
              </div>)}
          </div>

          <div className="mt-8 rounded-2xl border border-gold/25 bg-gold/10 p-5" data-id="element-60">
            <h4 className="font-semibold text-gold-light" data-id="element-61">
              Who is this designed for?
            </h4>
            <div className="mt-4 grid gap-3 md:grid-cols-2" data-id="element-62">
              {['Dance fitness instructors teaching in gyms, studios, community centers, schools, or online', 'New instructors looking for a professional foundation from day one', 'Experienced instructors tired of spending evenings and weekends planning', 'Instructors teaching beginner, mixed-level, or advanced participants', 'Anyone who wants a real professional system behind every class'].map(item => <p key={item} className="flex gap-2 text-sm text-zinc-200" data-id="element-63">
                  <CheckCircle2Icon size={17} className="shrink-0 text-gold-light" data-id="element-64" />
                  {item}
                </p>)}
            </div>
          </div>

          <p className="mt-7 rounded-xl border border-gold/25 bg-charcoal p-5 text-sm leading-relaxed text-zinc-300" data-id="element-65">
            <strong className="text-gold-light" data-id="element-66">Result: </strong>Your students
            feel the professionalism from the very first beat. Every class feels
            intentional, energetic, and genuinely worth their time.
          </p>
        </motion.article>
      </div>
    </section>;
}